var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8843 5.35184C11.7276 4.90735 11.4415 4.51992 11.0628 4.23939C10.6841 3.95887 10.2301 3.7981 9.75926 3.77777H6.61111C5.98491 3.77777 5.38435 4.02653 4.94155 4.46932C4.49876 4.91212 4.25 5.51267 4.25 6.13888C4.25 6.76508 4.49876 7.36564 4.94155 7.80844C5.38435 8.25123 5.98491 8.49999 6.61111 8.49999H9.75926C10.3855 8.49999 10.986 8.74875 11.4288 9.19154C11.8716 9.63434 12.1204 10.2349 12.1204 10.8611C12.1204 11.4873 11.8716 12.0879 11.4288 12.5307C10.986 12.9735 10.3855 13.2222 9.75926 13.2222H6.61111C6.14026 13.2019 5.68627 13.0411 5.30757 12.7606C4.92886 12.4801 4.64277 12.0926 4.48611 11.6481M8.18519 1.41666V3.77777M8.18519 13.2222V15.5833",
    stroke: "currentColor",
    strokeWidth: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/Dollar.3243332fec04539a647d4612d3dbd602.svg";
export { ForwardRef as ReactComponent };